// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"2df85d5e5781ec988adb","655":"f77bcd09abc99ee2c600"}[chunkId] + ".js";
};